// extracted by mini-css-extract-plugin
export default {"operationGroup":"StudyBrowserDetail_operationGroup__diFqh","operationGroupItem":"StudyBrowserDetail_operationGroupItem__rtKLB"};